// extracted by mini-css-extract-plugin
export default {"signUpContainer":"SignUp_signUpContainer__QA8qZ"};